import React, { ReactNode } from 'react';
import { CompanyLogo } from '@/Components/shared';
import { Card, CardContent, CardHeader, CardTitle } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import SupportSection from './SupportSection';
import MeshBackgroundCenterOverlay from '@/Components/layouts/MeshBackroundCenterOverlay';

interface ErrorPageProps {
    errorTitle: string;
    errorBody?: ReactNode;
    errorLogo?: ReactNode;
}

const ErrorDialog = ({
    errorTitle = UIStrings.OopsError,
    errorBody = UIStrings.SomethingWentWrongLong,
    errorLogo,
}: ErrorPageProps) => {
    return (
        <MeshBackgroundCenterOverlay>
            {errorLogo || (
                <CompanyLogo
                    width={195}
                    height={37.5}
                    color="primary"
                    className="mb-8 shrink-0"
                    aria-label={UIStrings.CompanyLogo}
                />
            )}
            <Card className="border-border w-full overflow-hidden rounded-2xl border drop-shadow-xl">
                <CardHeader className="gap-0 px-6 pt-6 pb-4">
                    <CardTitle className="text-foreground text-xl font-semibold tracking-tight md:text-2xl">
                        {errorTitle}
                    </CardTitle>
                </CardHeader>
                <CardContent className="px-6 pt-6 pb-6">{errorBody}</CardContent>
            </Card>
            <SupportSection />
        </MeshBackgroundCenterOverlay>
    );
};

export default ErrorDialog;
